(() => {
  const initGallery = (gallery) => {
    if (!(gallery instanceof HTMLElement)) return;
    if (gallery.dataset.bbGalleryInit === 'true') return;

    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;

    const prev = viewer.querySelector('.product-gallery-bb__arrow--prev');
    const next = viewer.querySelector('.product-gallery-bb__arrow--next');
    if (!prev || !next) return;

    gallery.dataset.bbGalleryInit = 'true';

    const slides = () => Array.from(viewer.querySelectorAll('[id^="Slide-"][data-media-id]'));

    const activeIndex = () => {
      const all = slides();
      const idx = all.findIndex((slide) => slide.classList.contains('is-active'));
      return idx >= 0 ? idx : 0;
    };

    const syncDisabled = () => {
      const all = slides();
      const i = activeIndex();
      if (all.length < 2) {
        prev.setAttribute('disabled', 'disabled');
        next.setAttribute('disabled', 'disabled');
        return;
      }
      if (i <= 0) prev.setAttribute('disabled', 'disabled');
      else prev.removeAttribute('disabled');
      if (i >= all.length - 1) next.setAttribute('disabled', 'disabled');
      else next.removeAttribute('disabled');
    };

    const go = (delta) => {
      const all = slides();
      if (all.length < 2) return;
      const i = activeIndex();
      const nextIndex = Math.min(all.length - 1, Math.max(0, i + delta));
      if (nextIndex === i) return;
      const mediaId = all[nextIndex].getAttribute('data-media-id');
      if (!mediaId) return;

      if (typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(mediaId, false);
      } else {
        // Fallback when media-gallery isn't upgraded yet: manual scroll + active class
        all.forEach((slide) => slide.classList.remove('is-active'));
        all[nextIndex].classList.add('is-active');
        const list = viewer.querySelector('[id^="Slider-Gallery"]');
        if (list) {
          list.scrollTo({ left: all[nextIndex].offsetLeft, behavior: 'smooth' });
        }
      }
      window.requestAnimationFrame(syncDisabled);
    };

    const onArrowClick = (event, delta) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      go(delta);
    };

    prev.addEventListener('click', (event) => onArrowClick(event, -1), true);
    next.addEventListener('click', (event) => onArrowClick(event, 1), true);

    gallery.addEventListener('slideChanged', syncDisabled);
    viewer.addEventListener('slideChanged', syncDisabled);

    const thumbs = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (thumbs) {
      thumbs.querySelectorAll('button').forEach((btn) => {
        btn.addEventListener('click', () => window.requestAnimationFrame(syncDisabled));
      });
    }

    syncDisabled();
  };

  const boot = (root) => {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('media-gallery').forEach(initGallery);
  };

  window.BBProductGallery = {
    init: initGallery,
    boot,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
